/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect} from 'react'
import {TabLavanderiaModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {EquipmentModel} from '../../../../model'
import {getEquipment} from '../../../../services'
import {MasiveUploadEquipment} from '../form/MasiveUploadEquipment'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useCompany, useClient, useSite, useCamp} from '../../../../../central/hooks'
import useTableForMaster from '../../../../hooks/useTableForMaster'

const TableEquipment: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()
  const {searchValues, clearSearchValues} = useKhipu()
  const {companyList, getCompanyList} = useCompany()
  const {statusOperational, getStatusOperationalList} = useTableForMaster()
  const {clientList, getClientList} = useClient()
  const {siteList, getSiteList} = useSite()
  const {campList, getCampList} = useCamp()
  const getEquipList = async () => {
    changeCurrentTabItem({...currentTabItem, loadingTable: false})

    setLoading(true)
    clearSelected()
    const response = await getEquipment(searchValues, pagination.currentPage)
    if (!response.data.error) {
      setData(response.data.data)
      setPagination({
        ...pagination,
        totalResults: response.data.total,
      })
    }
    setLoading(false)
  }

  useEffect(() => {
    getCompanyList()
    getClientList()
    getSiteList()
    getCampList()
    getStatusOperationalList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getEquipList()
    if (currentTabItem.loadingTable || updateTable) {
      clearSelected()
      getEquipList()
      setUpdateTable(false)
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [pagination.currentPage, currentTabItem.loadingTable, updateTable])
  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-equipment',
      },
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<EquipmentModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} showSelect={false} />,
      id: 'selection',
      Cell: ({...props}) => (
        <KTableSelectionCellNonMultiple
          id={props.data[props.row.index].id}
          clickHandler={handleGetId}
        />
      ),
    },

    {
      Header: (props) => (
        <KTableHeader
          tableProps={props}
          title='Campamento'
          name='campamentoId'
          selecteable
          data={campList}
        />
      ),
      accessor: 'nombreCampamento',
    },
    {
      Header: (props) => (
        <KTableHeader
          tableProps={props}
          title='Nomenclatura de máquina'
          name={'nombre'}
          searcheable
        />
      ),
      accessor: 'nombre',
    },
    {
      Header: (props) => (
        <KTableHeader tableProps={props} title='Marca' name={'marca'} searcheable />
      ),
      accessor: 'marca',
    },
    {
      Header: (props) => (
        <KTableHeader tableProps={props} title='Modelo' name={'modelo'} searcheable />
      ),
      accessor: 'modelo',
    },
    {
      Header: (props) => (
        <KTableHeader tableProps={props} title='Año de fabricación' name={'fabricacion'} dateable />
      ),
      accessor: 'fabricacion',
    },
    {
      Header: (props) => (
        <KTableHeader tableProps={props} title='Capacidad' name={'capacidad'} searcheable />
      ),
      accessor: 'capacidad',
    },
    {
      Header: (props) => (
        <KTableHeader tableProps={props} title='Serie' name={'serie'} searcheable />
      ),
      accessor: 'serie',
    },
    {
      Header: (props) => (
        <KTableHeader
          tableProps={props}
          title='Último mantenimiento'
          name={'ultimoMantenimiento'}
          dateable
        />
      ),
      accessor: 'ultimoMantenimiento',
    },
    {
      Header: (props) => (
        <KTableHeader
          tableProps={props}
          title='Estado'
          name='estado'
          selecteable
          data={statusOperational}
        />
      ),
      accessor: 'estado',
    },
    {
      Header: (props) => (
        <KTableHeader
          tableProps={props}
          title='Compañía'
          name='companiaId'
          selecteable
          data={companyList}
        />
      ),
      accessor: 'nombreCompania',
    },
    {
      Header: (props) => (
        <KTableHeader
          tableProps={props}
          title='Cliente'
          name='clienteId'
          selecteable
          data={clientList}
        />
      ),
      accessor: 'nombreCliente',
    },
    {
      Header: (props) => (
        <KTableHeader tableProps={props} title='Site' name='siteId' selecteable data={siteList} />
      ),
      accessor: 'site',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleViewPanel(props)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableEquipmentWrapper = () => {
  const {isAllowed} = useLavanderia()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Equipos</Tab>
            {isAllowed('MASIVO') && <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva</Tab>}
          </TabList>
          <TabPanel>
            <TableEquipment />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <MasiveUploadEquipment />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableEquipmentWrapper}
